import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUnknownLanguageDark = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 58,
	height: 58,
	viewBox: "0 0 58 58",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M33.0156 9.03501C31.9964 8.84086 30.9771 9.47184 30.783 10.4911L23.1627 47.7188C22.9685 48.738 23.5995 49.7573 24.6188 49.9515C24.7644 50 24.8615 50 25.0071 50C25.8807 50 26.6573 49.369 26.8515 48.4954L34.4717 11.2677C34.7144 10.2484 34.0835 9.22915 33.0156 9.03501Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M49.3726 26.7994L38.4518 18.985C37.6267 18.354 36.4133 18.5481 35.8308 19.4218C35.1998 20.2469 35.394 21.4603 36.2676 22.0428L46.4604 29.3718L36.2191 36.9436C35.394 37.5745 35.1998 38.7394 35.8308 39.5645C36.2191 40.0499 36.753 40.3411 37.3355 40.3411C37.7237 40.3411 38.112 40.2441 38.4518 39.9528L49.3726 31.8957C50.1977 31.3133 50.6831 30.3426 50.6831 29.3718C50.6831 28.4011 50.1977 27.3818 49.3726 26.7994Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.8522 19.4218C21.2213 18.5967 20.0564 18.354 19.2313 18.985L8.31049 26.7994C7.48537 27.3818 7 28.3525 7 29.3718C7 30.3911 7.48537 31.3133 8.26195 31.9443L19.1827 40.0014C19.5225 40.244 19.9108 40.3896 20.2991 40.3896C20.8815 40.3896 21.4639 40.147 21.8037 39.6131C22.4347 38.7879 22.2405 37.5745 21.4154 36.9921L11.2227 29.3718L21.4154 22.0428C22.2891 21.4603 22.4832 20.2954 21.8522 19.4218Z",
			fill: "currentColor"
		})
	]
});
const ForwardRef = forwardRef(SvgUnknownLanguageDark);
export { ForwardRef as ReactComponent };
